import {
    InfoCircleOutlined,
    InfoCircleFilled,
    LoadingOutlined,
    MinusCircleOutlined,
    PlusCircleOutlined,
    WarningOutlined,
} from '@ant-design/icons';
import { Collapse, Layout, Steps, Tabs } from 'antd';
import Button from 'components/ui/base/button/Button';
import styled from 'styled-components';
import { colors, fonts } from 'theme';
import NewButton from 'components/new-ui/base/button/Button';

const { Panel } = Collapse;
const { Header, Sider, Content } = Layout;

interface DeclarationButtonProps {
    error?: boolean;
    marginRight?: string;
    active?: boolean;
    left?: boolean;
}

interface ActionButtonProps {
    primary?: boolean;
}

interface HeightProps {
    $hasLeftNavigation?: boolean;
    $hasAlert?: boolean;
    collapsedFooter?: boolean;
    collapsedHeader?: boolean;
}

export const FormDiv = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
`;

export const TabDiv = styled.div`
    margin-left: 2px;
    &.tab-error {
        outline: 2px solid ${colors.lightRed};

        &:hover {
            outline: 2px solid ${colors.lightRed};
        }
    }
`;

export const StyledPanel = styled(Panel)`
    font-size: 2.4rem;
    font-weight: ${fonts.weight.bold};
    line-height: 3.2rem;
    border: none;

    .ant-collapse-header-text {
        width: 100%;
    }

    .ant-collapse-arrow {
        right: 40px !important;
    }
`;

export const StyledButton = styled(Button)<ActionButtonProps>`
    padding: 0 16px;
    border: 1px solid ${colors.brand6};
    color: ${colors.brand6};
    ${({ type }) => (type === 'primary' ? `background-color: ${colors.brand6};` : '')}
    ${({ type }) => (type === 'primary' ? `color: ${colors.white};` : '')}
    border-radius: 8px;
    transition: 0.2s;

    span {
        font-weight: 300;
    }

    &:hover {
        background-color: ${colors.brand6};
        ${({ primary }) => (primary ? `` : 'color: white;')}
        opacity: 0.8;
    }

    &:focus {
        border: 1px solid ${colors.brand6};

        color: ${({ primary }) => (primary ? `color: ${colors.brand6}` : 'color: white')};
    }
`;

export const StyledTabs = styled(Tabs)`
    display: flex;
    color: ${colors.darkPurple};
    overflow: visible;
    font-family: Open Sans;
    font-style: normal;
    font-weight: ${fonts.weight.regular};
    font-size: 16px;
    line-height: 24px;
    background: ${colors.offWhite};
    width: 100%;

    .ant-tabs-tab {
        font-size: 16px;
        cursor: pointer;
    }

    .ant-tabs-tab:hover {
        color: rgba(56, 55, 82, 1);
    }

    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: ${colors.brand6};
        text-shadow: 0 0 0.25px currentColor;
        font-family: Open Sans;
        font-style: normal;
        font-weight: ${fonts.weight.semibold};
        font-size: 16px;
        line-height: 24px;
    }

    .ant-tabs-ink-bar {
        background: ${colors.brand6};
        height: 2px;
    }
`;

export const StyledMinusCircleOutlined = styled(MinusCircleOutlined)`
    color: ${colors.lightBlue};
    font-size: 2.1rem;
`;
export const StyledPlusCircleOutlined = styled(PlusCircleOutlined)`
    color: ${colors.lightBlue};
    font-size: 2.1rem;
`;

export const ExpandedIconDiv = styled.div`
    margin-top: 0.4rem;
`;

export const VerticalNav = styled.div`
    overflow: hidden;
`;

export const StyledInfoCircleFilled = styled(InfoCircleFilled)`
    margin-left: 0.8rem;
    font-size: 1.4rem;
    align-items: center;
    display: flex;
    color: ${colors.darkGrey2};
`;

export const StyledInfoCircleOutlined = styled(InfoCircleOutlined)`
    margin-left: 0.8rem;
    font-size: 1.4rem;
    align-items: center;
    display: flex;
    color: ${colors.grey9};
`;

export const FilterCustomButtom = styled(Button)`
    border-color: ${colors.purpleBlue};
    color: ${colors.purpleBlue};
    &:hover {
        background: ${colors.purpleBlue};
        color: ${colors.white};
        border-color: ${colors.white};
    }
`;

export const FormTabsWrapper = styled.span<DeclarationButtonProps>`
    background: ${({ error }) => (error ? 'var(--dust-red-5)' : 'var(--gray-3)')};
    display: flex;
    gap: 2px;
    padding: 2px;
    border-radius: 8px;
`;

export const BtMasterInformationItemDetails = styled(NewButton)<DeclarationButtonProps>`
    background: ${({ error }) => (error ? colors.error : 'var(--gray-1)')};
    margin-right: ${({ marginRight }) => (marginRight ? `${marginRight}rem` : 0)};
    border: 0;
    outline: 0;
    border-bottom: 0;
    color: ${({ error }) => (error ? colors.white : colors.darkPurple)};
    font-weight: ${fonts.weight.semibold};
    box-shadow: none;

    &:hover,
    &:focus,
    &:active {
        color: ${({ error }) => (error ? ' var(--gray-1)' : 'var(--brand-5)')};
        background: ${({ error }) => (error ? 'var(--dust-red-4)' : 'var(--gray-1)')};
    }
`;

export const BtMasterGoodsSelected = styled(NewButton)<DeclarationButtonProps>`
    display: inline-flex;
    padding: 12px;
    align-items: center;
    ${({ left }) => (left ? 'margin-right: 0' : 'margin-left: 0')};
    background: ${({ error }) => (error ? colors.error : 'var(--gray-1)')};
    border-radius: 6px;
    margin-right: ${({ marginRight }) => (marginRight ? `${marginRight}rem` : 0)};
    border: 0;
    outline: 0;
    color: ${({ error }) => (error ? colors.white : colors.brand6)} !important;
    box-shadow: none;

    &:hover,
    &:focus,
    &:active {
        color: ${({ error }) => (error ? ' var(--gray-1)' : 'var(--brand-5)')};
        background: ${({ error }) => (error ? 'var(--dust-red-4)' : 'var(--gray-1)')};
    }
`;

export const BtMasterGoodsNotSelected = styled(NewButton)<DeclarationButtonProps>`
    display: inline-flex;
    align-items: center;
    padding: 12px;
    ${({ left }) => (left ? 'margin-right: 0' : 'margin-left: 0')};
    background: ${({ error }) => (error ? 'var(--dust-red-5)' : 'var(--gray-3)')};
    border: 0;
    outline: 0;
    border-radius: 6px;
    box-shadow: none;

    &:hover,
    &:focus,
    &:active {
        color: ${({ error }) => (error ? ' var(--gray-1)' : 'var(--brand-5)')};
        background: ${({ error }) => (error ? 'var(--dust-red-4)' : 'var(--gray-1)')};
    }
`;

export const InvalidIcon = styled(WarningOutlined)`
    font-size: 1.8rem;
`;

export const ExpandButton = styled(Button)`
    height: 4rem;
    width: 20.4rem;
`;

export const StyledHeader = styled(Header)`
    background: ${colors.offWhite};
    padding: 0;
    z-index: 2;
    position: sticky;
    width: 100%;
    top: 0;
    height: min-content;
`;

export const StyledLayout = styled(Layout)`
    background: transparent;
    padding: 0;
    height: 100%;
`;

export const StyledContent = styled(Content)<HeightProps>`
    height: 100%;
    background: ${colors.offWhite} !important;
    padding: 0;
    position: relative;
    margin-left: ${({ $hasLeftNavigation }) => ($hasLeftNavigation ? '2rem' : '0')};
    overflow: auto;
    overflow-x: hidden;

    ::-webkit-scrollbar {
        width: 0px;
    }
`;

export const StyledSider = styled(Sider)<HeightProps>`
    height: 100%;
    background: ${colors.offWhite};
    padding: 0;
    min-width: 26.4rem !important;
    max-width: 26.4rem !important;
    overflow-y: auto;

    ::-webkit-scrollbar {
        width: 0px;
    }
`;

export const StyledSteps = styled(Steps)<{
    itemDetails?: boolean;
}>`
    min-width: 26.4rem !important;
    padding: 12px;

    .ant-steps-item-tail::after {
        background-color: ${colors.buttonGrey} !important;
    }

    .ant-steps-icon-dot {
        background-color: ${colors.grey7} !important;
        width: 14px;
        height: 14px;
        border: 2px solid ${colors.grey7};
    }

    .ant-steps-item-finish .ant-steps-icon-dot {
        background-color: ${colors.grey7} !important;
        border: 2px solid ${colors.grey7};
    }

    .ant-steps-item-active .ant-steps-icon-dot {
        background-color: ${colors.brand6} !important;
        border: 2px solid ${colors.brand6};
    }

    .ant-steps-item-title {
        color: ${colors.grey7} !important;
        padding-bottom: 4px;
    }

    .ant-steps-item-active .ant-steps-item-title {
        color: ${colors.grey9} !important;
    }

    /* Error state */
    .ant-steps-item.step-error .ant-steps-icon-dot {
        background-color: var(--dust-red-6) !important;
        border: 2px solid var(--dust-red-6) !important;
    }

    .ant-steps-item.step-error .ant-steps-item-title {
        color: var(--dust-red-6) !important;
    }

    // Non mandatory fields

    ${({ itemDetails }) =>
        itemDetails
            ? `.ant-steps-item:not(.ant-steps-item-active):nth-child(3) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(5) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(6) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(7) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(8) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(9) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(10) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(11) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(12) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(13) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(14) .ant-steps-icon-dot
        {
            background: none !important;
        }`
            : `.ant-steps-item:not(.ant-steps-item-active):nth-child(7) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(10) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(11) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(12) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(13) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(14) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(15) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(16) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(17) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(18) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(19) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(20) .ant-steps-icon-dot,
        .ant-steps-item:not(.ant-steps-item-active):nth-child(21) .ant-steps-icon-dot
        {
            background: none !important;
        }`}
`;

export const ViewOnlyContent = styled(Content)<{ hasLeftNavigation?: boolean }>`
    background: ${colors.white};
    padding: 0;
    margin-left: ${({ hasLeftNavigation }) => (hasLeftNavigation ? '28rem' : '0')};
    overflow: auto;
    height: calc(100vh - 26.3rem);
    padding-right: 4px;
`;

export const ViewOnlySider = styled(Sider)`
    background: ${colors.offWhite};
    padding: 0;
    position: fixed;
    height: calc(100vh - 26.3rem);
    min-width: 26.4rem !important;
    max-width: 26.4rem !important;
    overflow-y: auto;
`;

export const SubmitLoading = styled(LoadingOutlined)`
    font-size: 1.6rem;
    margin-left: 1rem;
`;

export const NumberItemsRounderInfo = styled.span`
    width: 2.22rem;
    height: 2.22rem;
    line-height: 2.22rem;
    font-size: 1.3rem;
    overflow: hidden;
    border-radius: 50%;
    background: ${colors.darkPurple};
    color: ${colors.white};
    margin-left: 0.5rem;
    white-space: nowrap;
    text-align: center;
    vertical-align: text-bottom;
`;

export const Tags = styled.div`
    max-width: 500px;
    display: flex;
`;
